import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    InviteToEventMutation,
    InviteToEventMutationVariables,
} from './Invite.mutations.generated'

export const INVITE_TO_EVENT: TypedDocumentNode<
    InviteToEventMutation,
    InviteToEventMutationVariables
> = gql`
    mutation InviteToEvent($input: inviteToEventInput!) {
        inviteToEvent(input: $input) {
            event {
                ... on Event {
                    guid
                }
            }
            status {
                item
                status
            }
        }
    }
`
